import { MutableRefObject, useEffect, useRef, useState } from 'react';

const useScrollCheck = (): { isScrollBreak: boolean } => {
  const [isScrollBreak, setIsScrollBreak] = useState(false);
  const prevScrollPos: MutableRefObject<number> = useRef(0);
  const handleScroll = () => {
    const position:number = window.pageYOffset;
    setIsScrollBreak(prevScrollPos.current < position);
    prevScrollPos.current = position;
  };
  useEffect(() => {
    // binding scroll event listener that hides top header bar
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return { isScrollBreak };
};

export default useScrollCheck;
